import { render } from "./EditPagePreviewPage.vue?vue&type=template&id=22c3e62e&scoped=true"
import script from "./EditPagePreviewPage.vue?vue&type=script&lang=js"
export * from "./EditPagePreviewPage.vue?vue&type=script&lang=js"

import "./EditPagePreviewPage.vue?vue&type=style&index=0&id=22c3e62e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22c3e62e"]])

export default __exports__